__turbopack_context__.v({
  "titleWrapper": "style-module-scss-module__ID4pnq__titleWrapper",
  "wrapper": "style-module-scss-module__ID4pnq__wrapper",
});
